export enum ControlDirection {
  TURN_LEFT = 'TURN_LEFT',
  TURN_RIGHT = 'TURN_RIGHT',
  BACK_TO_NORMAL = 'BACK_TO_NORMAL',
}

export enum ControlSpeed {
  SLOW_DOWN = 'SLOW_DOWN',
  SPEED_UP = 'SPEED_UP',
  BRAKE = 'BRAKE',
}

export enum ControlType {
  SPEED = 'SPEED',
  ANGLE = 'ANGLE',
}

export enum CommandType {
  NORMAL = 'NORMAL',
  SUPER = 'SUPER',
}

export enum ModuleName {
  SUPERVISOR = 'supervisor',
}

export enum ControlState {
  OK = 'OK',
  TIME_EXCEPTION = 'TIME_EXCEPTION',
}
// 轮询请求的时间间隔（ms）
export const controlRequestDuration = 125;

// 接口返回时从前端->服务端->车端->服务端->前端 响应时间的最大间隔（s）
export const controlResponseDelay = 10;

// 判断接口超时的时间（ms）
export const controlResponseTimeout = 10000;

// 视频最大延时 (s)
export const videoDelayLimit = 1;

// 视频、3D地图最大延时(s)
export const maxVisibleDelayLimit = 3;

// 遥控最大速度
export const MaxSpeedMap = new Map([
  [CommandType.NORMAL, 1.2],
  [CommandType.SUPER, 0.8],
]);

export const ModalInfoText = [
  '车辆将脱离安全模块管理，您是否确定开启强制远程遥控？',
  '当前远程操作延时严重，车辆脱离安全模块管理具有风险，您是否确定开启强制远程遥控？',
];
